module.exports = __webpack_public_path__ + "img/firs-login.08b8e542.png";